import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page94() {
  useEffect(() => {
    document.title = "Маяк — Страница 93"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page92" />
        <ForwardLink href="/page94" />
      </div>

      <p style={{ textAlign: "right" }}>93.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Как и мой последний помощник.
      </p>
      <p>МОЛОДОЙ засыпает илом лицо СТАРИКА...</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Заткнись, пес. Полируй свою медь.
      </p>
      <p>Он продолжает закапывать...</p>
      <p>СТАРИК смеется, кровь течет у него изо рта. Умирает.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Ты сказал, что ты богобоязненный человек,<br/>
        Томми? (смеется) Это правда,<br/>
        Томми!
      </p>
      <p>Еще больше ила на него...</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        О, какие многоликие твари всплывают из<br/>
        человеческих умов и плавятся в огне,<br/>
        Прометеем украденным, что опалит глаза<br/>
        божественным стыдом и ужасом
      </p>
      <p>Еще больше ила на него...</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        и низвергнет их всех в бездну к Дэви Джонсу.<br/>
        Другие же, все еще слепые, но<br/>
        увидят в нем все божественные благодати<br/>
        и отправятся в Фиддлерс-Грин, где никто<br/>
        не страдает от нужды и тяжелого труда, но где мы<br/>
      </p>
      <p>Земля на его лице...</p>
      <p style={{ textAlign: "center" }}>извечны</p>
      <p>Ил...</p>
      <p style={{ textAlign: "center" }}>изменчивы</p>
      <p>Еще больше ила на его лице...</p>
      <p style={{ textAlign: "center" }}>
        и неизменны, как вода, что<br/>
        охватывает земной шар.
      </p>
      <p>Еще больше ила...</p>
      <p style={{ textAlign: "center" }}>
        Это правда. <u>И</u> <u>ты</u> <u>будешь</u><br/>
        <u>наказан</u>.
      </p>
      <p>СТАРИК задыхается от земли и ила.</p>
      <p style={{ textAlign: "right" }}>93.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page92" />
        <ForwardLink href="/page94" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710718638/the-lighthouse-script/ufs0lvcqj3trlnzfxac5.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page94;
